export default "__VITE_ASSET__CVdc8oJv__"